import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/UserAuth';
import { DarkMode } from '../context/DarkMode';

function Navbar() {
  const navigate = useNavigate();
  const { Logout } = useAuth();
  const { ToggleMode, mode } = DarkMode();

  // from localstorage
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  const handleLogOut = () => {
    //? from context
    Logout();

    //! navigate to login page
    navigate('/login');
  };

  // ###################################################################
  return (
    <div className='container navbar'>
      <nav className='navbar navbar-expand-lg navbar-dark fixed-top' style={{ backgroundColor: '#d63384' }}>
        <div className='container-fluid'>
          <Link className='navbar-brand mx-5' to='/'>
            <strong>QuoteWebsite</strong>
          </Link>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              <li className='nav-item active'>
                <Link className='nav-link ' aria-current='page' to='/'>
                  <strong>Home</strong>
                </Link>
              </li>
              <li className='nav-item active'>
                <Link className='nav-link' to={userId ? `/addQuote/${userId}` : '/login'}>
                  <strong>AddQuote</strong>
                </Link>
              </li>
              <li className='nav-item active'>
                <Link className='nav-link' to={userId ? `/profile/${userId}` : '/login'}>
                  <strong>profile</strong>
                </Link>
              </li>
            </ul>

            {token && userId && (
              <button type='button' className='btn btn-outline-dark me-5' onClick={handleLogOut}>
                <strong>Logout</strong>
              </button>
            )}

            {!token && !userId && (
              <>
                <button className='btn btn-outline-success text-white' onClick={() => navigate('/login')}>
                  <strong>Login</strong>
                </button>
                <button className='btn btn-outline-info text-white ms-4' onClick={() => navigate('/signup')}>
                  <strong>SignUp</strong>
                </button>
              </>
            )}

            <div className='form-check form-switch mx-2 my-1'>
              <input className='form-check-input' onClick={ToggleMode} type='checkbox' id='darkMode' />
              <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>
                {mode === 'light' ? 'LightMode' : 'DarkMode'}
              </label>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
